import { createApp } from "vue";
import App from "@/App.vue";
import { registerAppGlobals } from "@/bootstrap/registerAppGlobals";
import { createModernI18n } from "@/plugins/i18n/modern";
import { createModernVuetify } from "@/plugins/vuetify/modern";
import { createModernRouter } from "@/router/modern";
import pinia from "@/store/pinia";

export function createModernApp() {
  const app = createApp(App);
  const i18n = createModernI18n();
  const vuetify = createModernVuetify();
  const router = createModernRouter();

  registerAppGlobals(app);
  app.use(pinia);
  app.use(router);
  app.use(i18n);
  app.use(vuetify);

  return app;
}

export function mountModernApp(selector = "#app") {
  return createModernApp().mount(selector);
}